import { jsx as _jsx } from "react/jsx-runtime";
import { Link } from 'react-router-dom';
import { useAppSelector } from '../../hooks';
export const DeviceLink = props => {
    const devices = useAppSelector(state => state.definitions.devices);
    const device = devices[props.device_id];
    if (device == undefined) {
        return (_jsx("div", { children: "Unknown device" }));
    }
    else {
        return _jsx(Link, { to: '/device/' + device.id, style: { color: 'black' }, children: device.title });
    }
};
